import AICC from '../AICC';

window.AICC = AICC;
